import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "./redirectURL";
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import Select from "react-select";
import "../assets/css/inventorymanagement.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const NewScreen = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [columnWithDefs, setColumnWithDefs] = useState([]);
  const [phaseKeyValues, setPhaseKeyValues] = useState([]);
  const [phaseOptions, setPhaseOptions] = useState([]);
  const [phase, setPhase] = useState({ label: "ALL", value: "" });
  const [availableDates, setAvailableDates] = useState([]);
  const [chartType, setChartType] = useState("line");
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [currentUploadedDate, setCurrentUploadedDate] = useState("");
  const [storeId, setStoreId] = useState({
    label: "Demand Plan Data",
    value: "demand_plan_data",
  });
  const [storeOptions, setStoreOptions] = useState([
    { label: "Demand Plan Data", value: "demand_plan_data" },
    { label: "Warehouse Data", value: "warehouse_data" },
  ]);
  const [skuChartData, setSkuChartData] = useState([]);
  const [selectedSku, setSelectedSku] = useState(null);
  const [showChart, setShowChart] = useState(false);
  const [dataExists, setDataExists] = useState(false);
  const [uploadedMonthYear, setUploadedMonthYear] = useState({ month: null, year: null });

  const handleCellClick = (event) => {
    if (storeId.value !== "demand_plan_data") return;
    if (event.colDef.field === "sku" || event.colDef.field === "sku_key") {
      const sku = event.value;
      const row = event.data;
      let currentRow = row;

      if (phase?.value) {
        const keys = phaseKeyValues[phase.value];
        const filteredRow = keys.reduce((acc, key) => {
          if (row.hasOwnProperty(key)) {
            acc[key] = row[key];
          }
          return acc;
        }, {});
        currentRow = filteredRow;
      }

      const monthKeys = Object.keys(currentRow).filter((k) =>
        /^[a-z]{3}\d{2}$/.test(k)
      );

      const chartData = monthKeys.map((month) => ({
        month: month.toUpperCase(),
        value: currentRow[month],
      }));

      setSelectedSku(sku);
      setSkuChartData(chartData);
      setShowChart(true);
    }
  };

  const whSplitCols = [
    { headerName: "SKU", field: "sku" },
    { headerName: "Percentage", field: "percentage" },
    { headerName: "Warehouse", field: "warehouse" },
    { headerName: "File Name", field: "file_name", hide: true },
    { headerName: "Sheet Name", field: "sheet_name", hide: true },
    { headerName: "Process", field: "process", hide: true },
    { headerName: "Uploaded Date", field: "uploaded_date" },
  ];

  const resetFilters = () => {
    setStoreId({ label: storeOptions[0]["label"], value: "" });
  };

  const triggerUserAction = (trigerdata) => {
    redirectURL.post("inventory/triggerUserAction", trigerdata);
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("");
    setUploadedFileData([]);
    setDataExists(false);
    setUploadedMonthYear({ month: null, year: null });
  };

  const onChangeDataType = async (selectedOption) => {
    setStoreId(selectedOption);
  };

  const allowedMonths = [...new Set(availableDates.map((d) => d.slice(0, 7)))];

  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value;
    if (allowedMonths.includes(selectedMonth)) {
      setCurrentInvoiceDate(selectedMonth + "-01");
    } else {
      alert("Data not available for the selected Month");
      e.target.value = currentinvoiceDate.slice(0, 7);
    }
  };

  const sideBar = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
        },
      ],
    }),
    []
  );

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left",
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center",
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" },
    ],
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  };

  const getResetMasterData = async () => {
    try {
      var params = {
        date: new Date().toISOString().split("T")[0].slice(0, 7),
        datatype: storeOptions[0].value || "ALL",
      };

      const response = await redirectURL.post(
        "inventory/getdemandplandata",
        params
      );
      if (response.data.status === "success") {
        if (response.data.data) {
          const defaultData = response.data.data.shelf_life_master;
          setAvailableDates(response.data.data.avaiDates);
          setRowData(defaultData);
          setStoreId(storeOptions[0]);
          setColumnWithDefs([]);
          setCurrentInvoiceDate(new Date().toISOString().split("T")[0]);
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    } catch (error) {
      console.error("Error fetching Historic  data:", error);
      setBasicTitle("Failed to fetch Historic  data");
      setBasicType("error");
      setShow(true);
    }
  };

  const getDemandPlanData = async () => {
    try {
      var params = {
        date: currentinvoiceDate.slice(0, 7),
        datatype: storeId.value || "ALL",
      };

      const response = await redirectURL.post(
        "inventory/getdemandplandata",
        params
      );
      if (response.data.status === "success") {
        if (response.data.data) {
          const defaultData = response.data.data.shelf_life_master;
          setRowData(defaultData);
          setAvailableDates(response.data.data.avaiDates);

          if (storeId.value === "demand_plan_data") {
            setColumnWithDefs([]);
          } else if (storeId.value === "warehouse_data") {
            setColumnWithDefs(whSplitCols);
          }
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    } catch (error) {
      console.error("Error fetching Historic  data:", error);
      setBasicTitle("Failed to fetch Historic  data");
      setBasicType("error");
      setShow(true);
    }
  };

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getDemandPlanData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  };

  useEffect(() => {
    const getData = async () => {
      await getMainData();
    };
    getData();
  }, []);

  const getPhases = (row) => {
    if (!row) return [];
    return Object.keys(row).filter(
      (key) =>
        ![
          "_id",
          "file_name",
          "sheet_name",
          "process",
          "uploaded_date",
          "channel_type",
          "sku",
        ].includes(key)
    );
  };

  const createFinancialYearPhasesAndKeys = (keys) => {
    const monthOrder = [
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
      "jan",
      "feb",
      "mar",
    ];

    const filtered = keys.filter((key) => /^[a-z]{3}\d{2}$/.test(key));

    filtered.sort((a, b) => {
      const [m1, y1] = [a.slice(0, 3), parseInt(a.slice(3), 10)];
      const [m2, y2] = [b.slice(0, 3), parseInt(b.slice(3), 10)];
      const i1 = monthOrder.indexOf(m1);
      const i2 = monthOrder.indexOf(m2);
      return y1 !== y2 ? y1 - y2 : i1 - i2;
    });

    const phases = {};
    const phase_keys = [];

    filtered.forEach((key) => {
      const mon = key.slice(0, 3);
      const yy = parseInt(key.slice(3), 10);
      const fyStart = ["jan", "feb", "mar"].includes(mon) ? yy - 1 : yy;
      const fyEnd = fyStart + 1;
      const fyLabel = `FY-Apr-${String(fyStart).padStart(2, "0")}-Mar-${String(
        fyEnd
      ).padStart(2, "0")}`;
      if (!phases[fyLabel]) {
        phases[fyLabel] = [];
        phase_keys.push(fyLabel);
      }

      phases[fyLabel].push(key);
    });

    return { phase_keys, phases };
  };

  useEffect(() => {
    if (storeId.value === "demand_plan_data" && rowData.length > 0) {
      const keys = getPhases(rowData[0]);
      const { phase_keys, phases } = createFinancialYearPhasesAndKeys(keys);
      const phaseOptions = phase_keys.map((key) => ({
        label: key,
        value: key,
      }));
      phaseOptions.unshift({ label: "ALL", value: "" });
      setPhaseOptions(phaseOptions);
      setPhaseKeyValues(phases);

      if (
        phase?.value &&
        storeId.value === "demand_plan_data" &&
        rowData.length > 0
      ) {
        const currentRow = rowData[0];
        const phaseKeys = phases[phase.value];
        phaseKeys.unshift(
          "sku",
          "channel_type",
          "file_name",
          "sheet_name",
          "process",
          "uploaded_date"
        );

        const filteredRow = phaseKeys.reduce((acc, key) => {
          if (currentRow.hasOwnProperty(key)) {
            acc[key] = currentRow[key];
          }
          return acc;
        }, {});

        const dynamicCols = generateDpBaseCols(filteredRow);
        setColumnWithDefs(dynamicCols);
      } else {
        const currentRow = rowData[0];
        const dynamicCols = generateDpBaseCols(currentRow);
        setColumnWithDefs(dynamicCols);
      }
    }
  }, [rowData]);

  const generateDpBaseCols = (row) => {
    if (!row) return [];

    return Object.keys(row)
      .filter((key) => key !== "_id")
      .sort((a, b) => {
        const isSku = (key) => key === "sku" || key === "sku_key";
        const isChannel = (key) => key === "channel_type" || key === "channel";

        if (isSku(a)) return -1;
        if (isSku(b)) return 1;

        if (isChannel(a)) return -1;
        if (isChannel(b)) return 1;

        if (a === "uploaded_date") return 1;
        if (b === "uploaded_date") return -1;

        const fiscalMonthOrder = [
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC",
          "JAN",
          "FEB",
          "MAR",
        ];

        const extractParts = (key) => {
          const match = key.toUpperCase().match(/^([A-Z]{3})(\d{2})$/);
          if (!match) return { monthIndex: -1, year: 0 };
          const [_, month, year] = match;
          const monthIndex = fiscalMonthOrder.indexOf(month);
          return { monthIndex, year: parseInt(year, 10) };
        };

        const aParts = extractParts(a);
        const bParts = extractParts(b);

        if (aParts.monthIndex !== -1 && bParts.monthIndex !== -1) {
          if (aParts.year !== bParts.year) return aParts.year - bParts.year;
          return aParts.monthIndex - bParts.monthIndex;
        }

        if (aParts.monthIndex !== -1) return -1;
        if (bParts.monthIndex !== -1) return 1;

        return a.localeCompare(b);
      })

      .map((key) => {
        const baseCol = {
          headerName: formatHeader(key),
          field: key,
          hide: ["file_name", "sheet_name", "process"].includes(key),
        };

        if (key === "sku" || key === "sku_key") {
          baseCol.cellRenderer = (params) => {
            return (
              <a
                href="#"
                className="sku-link"
                style={{ color: "blue", textDecoration: "underline" }}
                data-sku={params.value}
              >
                {params.value}
              </a>
            );
          };
        }

        return baseCol;
      });
  };

  const formatHeader = (key) => {
    if (key.includes("_")) {
      return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    } else if (/^[a-z]{3}\d{2}$/i.test(key)) {
      const month = key.slice(0, 3).toLowerCase();
      const year = key.slice(3);
      return `${month.charAt(0).toUpperCase()}${month.slice(1)} ${year}`;
    } else {
      return key.replace(/\b\w/g, (l) => l.toUpperCase());
    }
  };

  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {
      fileInput.value = "";
    }

    setUploadedFileData([]);
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setCurrentUploadedDate("");
    setDataExists(false);
    setUploadedMonthYear({ month: null, year: null });
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setUploadedFileData([]);
    setCurrentUploadedDate("");
    setDataExists(false);
    setUploadedMonthYear({ month: null, year: null });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fileName = file.name;
    const uploadedDate = new Date().toISOString().split("T")[0];

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      let parsedData = {
        dpBase: [],
        whSplit: [],
      };

      function toSnakeCase(str) {
        return str
          .trim()
          .replace(/\s+/g, "_")
          .replace(/[A-Z]/g, (letter) => letter.toLowerCase())
          .replace(/[^a-z0-9_]/g, "");
      }

      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const sheetData = XLSX.utils.sheet_to_json(sheet, {
          raw: false,
          dateNF: "yyyy-mm-dd",
          defval: null,
        });

        const processedData = sheetData.map((item) => {
          const newItem = {};

          Object.entries(item).forEach(([key, value]) => {
            const trimmedKey = key?.toString().trim();
            const trimmedValue =
              typeof value === "string" ? value.trim() : value;

            if (trimmedValue !== null && trimmedValue !== "") {
              newItem[toSnakeCase(trimmedKey)] = trimmedValue;
            }
          });

          newItem.file_name = fileName;
          newItem.sheet_name = sheetName;
          newItem.process = 0;
          newItem.uploaded_date = uploadedDate;

          return newItem;
        });

        if (sheetName === "DP Base") {
          parsedData.dpBase = processedData;
        } else if (sheetName === "WH Split") {
          parsedData.whSplit = processedData;
        }
      });

      setUploadedFileData(parsedData);
    };

    reader.readAsArrayBuffer(file);
  };

  const getYearMonth = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return { month: null, year: null };
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return { month, year };
  };

  const checkDataExists = async (month, year) => {
    try {
      const params = {
        uploaded_month: month,
        uploaded_year: year
      };
      
      const response = await redirectURL.post(
        "inventory/checkDemandPlanDataExists",
        params
      );
      
      if (response.data.status === "success") {
        setDataExists(response.data.data.exists);
      }
    } catch (error) {
      console.error("Error checking data existence:", error);
      setDataExists(false);
    }
  };

  const handleUploadDateChange = (e) => {
    const date = e.target.value;
    setCurrentUploadedDate(date);
    
    if (date) {
      const { month, year } = getYearMonth(date);
      setUploadedMonthYear({ month, year });
      checkDataExists(month, year);
    } else {
      setDataExists(false);
      setUploadedMonthYear({ month: null, year: null });
    }
  };

  const onClickingRevoke = async () => {
    if (!uploadedMonthYear.month || !uploadedMonthYear.year) {
      setShow(true);
      setBasicType("warning");
      setBasicTitle("Please select a date first.");
      return;
    }

    if (!dataExists) {
      setShow(true);
      setBasicType("warning");
      setBasicTitle("No data exists for this date to revoke.");
      return;
    }

    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const params = {
        uploaded_month: uploadedMonthYear.month,
        uploaded_year: uploadedMonthYear.year
      };

      const response = await redirectURL.post(
        "inventory/revokeDemandPlanData",
        params
      );

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (response.data.status === "success") {
        setShow(true);
        setBasicType("success");
        setBasicTitle("Data revoked successfully");
        
        setCurrentUploadedDate("");
        setUploadedFileData([]);
        setDataExists(false);
        
        await getDemandPlanData();
        
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Revoked DP Data",
          status: "Success",
          path: window.location.pathname,
        };
        triggerUserAction(userData);
      } else {
        setShow(true);
        setBasicType("error");
        setBasicTitle("Failed to revoke data");
        
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Revoked DP Data",
          status: "Failure",
          path: window.location.pathname,
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to revoke data";
      setShow(true);
      setBasicType("error");
      setBasicTitle(errorMessage);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Revoked DP Data",
        status: "Failure",
        path: window.location.pathname,
      };
      triggerUserAction(userData);
    }
  };

  const onClickingFileSubmit = async () => {
    if (!uploadedFileData) {
      setShow(true);
      setBasicType("warning");
      setBasicTitle("Please upload a file to continue.");
      return;
    }

    if (dataExists) {
      setShow(true);
      setBasicType("warning");
      setBasicTitle("Data already exists for this date. Please revoke first or choose a different date.");
      return;
    }

    if (
      (!uploadedFileData.dpBase || uploadedFileData.dpBase.length === 0) &&
      (!uploadedFileData.whSplit || uploadedFileData.whSplit.length === 0)
    ) {
      setShow(true);
      setBasicType("warning");
      setBasicTitle("File has no valid DP Base or WH Split data.");
      return;
    }

    if (!uploadedFileData.dpBase || uploadedFileData.dpBase.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("DP Base data not found in file.");
      return;
    }

    if (!uploadedFileData.whSplit || uploadedFileData.whSplit.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("WH Split data not found in file.");
      return;
    }

    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const { month, year } = getYearMonth(currentUploadedDate);
      const params = {
        date: currentUploadedDate,
        uploaded_year: year,
        uploaded_month: month,
        dpBase: uploadedFileData.dpBase || [],
        whSplit: uploadedFileData.whSplit || [],
      };

      const response = await redirectURL.post(
        "inventory/storeDemandPlanData",
        params
      );

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (response.data.status === "success") {
        await getDemandPlanData();
        setShow(true);
        setBasicType("success");
        setBasicTitle("Data Uploaded Successfully");
        
        setDataExists(true);

        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Uploaded DP Data File",
          status: "Success",
          path: window.location.pathname,
        };
        triggerUserAction(userData);
      } else {
        setShow(true);
        setBasicType("info");
        setBasicTitle("Data Upload Failed");

        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Uploaded DP Data File",
          status: "Failure",
          path: window.location.pathname,
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to upload data";
      setShow(true);
      setBasicType("info");
      setBasicTitle(errorMessage);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Uploaded DP Data File",
        status: "Failure",
        path: window.location.pathname,
      };
      triggerUserAction(userData);
    }
  };

  const onClickUploadSkuMasterData = (event) => {
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25");
    setSliderTitle("Upload Demand Plan Data");
    setOverlyBlock("show-m");
    
    // Set current date when slider opens
    const today = new Date().toISOString().split("T")[0];
    setCurrentUploadedDate(today);
    
    // Check if data exists for current month
    const { month, year } = getYearMonth(today);
    setUploadedMonthYear({ month, year });
    checkDataExists(month, year);
  };

  const setfiltersData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getDemandPlanData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  };

  const onChangePhase = (option) => {
    setPhase(option);
  };

  const ChartModal = ({
    showChart,
    setShowChart,
    selectedSku,
    phase,
    skuChartData = [],
  }) => {
    if (!showChart) return null;

    const categories = skuChartData.map(
      (item) => item.month || item.category || ""
    );
    const seriesData = skuChartData.map((item) => Number(item.value) || 0);

    const options = {
      chart: {
        type: chartType,
        backgroundColor: "#fff",
        style: { fontFamily: "Arial, sans-serif" },
      },
      title: {
        text: `Monthly Trend for SKU: <span style="color:#000">${selectedSku}</span>`,
        align: "center",
        style: {
          color: "#93385D",
          fontSize: "20px",
        },
      },
      xAxis:
        chartType !== "pie"
          ? {
              categories,
              title: {
                text: phase?.value || "ALL Months",
                style: {
                  color: "#93385D",
                  fontSize: "14px",
                  fontWeight: "bold",
                },
              },
              labels: {
                style: { fontSize: "12px", color: "#000" },
              },
              gridLineWidth: 1,
              gridLineColor: "#e0e0e0",
              gridLineDashStyle: "Dash",
            }
          : undefined,
      yAxis:
        chartType !== "pie"
          ? {
              title: { text: "Value" },
              labels: { style: { fontSize: "12px" } },
              gridLineColor: "#e0e0e0",
              gridLineDashStyle: "Dash",
            }
          : undefined,

      tooltip: {
        valueSuffix: "",
        pointFormat: "{series.name}: <b>{point.y}</b>",
      },
      legend: {
        enabled: chartType === "pie",
      },
      series: [
        {
          name: "Monthly Sales",
          colorByPoint: chartType === "pie",
          data:
            chartType === "pie"
              ? skuChartData.map((item) => ({
                  name: item.month,
                  y: Number(item.value) || 0,
                }))
              : seriesData,
          color: chartType !== "pie" ? "#93385D" : undefined,
        },
      ],
      credits: {
        enabled: false,
      },
    };
    const chartTypes = ["column", "line", "pie", "bar", "area"];
    return (
      <div
        onClick={() => setShowChart(false)}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          backdropFilter: "blur(2px)",
          zIndex: 999,
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "24px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
            zIndex: 1000,
            width: "85%",
            maxWidth: "900px",
            borderRadius: "12px",
          }}
        >
          <button
            onClick={() => setShowChart(false)}
            style={{
              position: "absolute",
              top: "12px",
              right: "16px",
              background: "transparent",
              border: "none",
              fontSize: "20px",
              fontWeight: "bold",
              color: "#888",
              cursor: "pointer",
            }}
            title="Close"
          >
            &times;
          </button>

          <div style={{ marginTop: "25px", textAlign: "right" }}>
            <select
              value={chartType}
              onChange={(e) => setChartType(e.target.value)}
              style={{
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            >
              {chartTypes.map((type) => (
                <option key={type} value={type}>
                  {type.toUpperCase()}
                </option>
              ))}
            </select>
          </div>

          <HighchartsReact highcharts={Highcharts} options={options} />

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "8px",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", marginLeft: 30 }}
            >
              <div
                style={{
                  width: 12,
                  height: 12,
                  backgroundColor: "#93385D",
                  marginRight: 8,
                }}
              />
              <span style={{ fontSize: 14, color: "#93385D" }}>
                Monthly Sales
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          ></SweetAlert>
        </div>

        <div
          className="row"
          style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}
        >
          <form
            className="col-sm-12 p-0 mb-4"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="col-sm-8 row ">
              <div
                className="col-sm-3 mb-1"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Uploaded Month:
                </label>
                <input
                  type="month"
                  id="invoiceDate"
                  value={currentinvoiceDate.slice(0, 7)}
                  onChange={handleMonthChange}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                />
              </div>
              <div
                className="col-sm-3 mb-1"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label
                  htmlFor="storeId"
                  style={{ fontSize: "13px", fontWeight: "400" }}
                >
                  Data Type:
                </label>
                <Select
                  id="storeId"
                  value={storeId}
                  onChange={onChangeDataType}
                  options={storeOptions}
                  styles={selectStyles}
                />
              </div>
              {storeId?.value === "demand_plan_data" && (
                <div className="col-sm-3 mb-1">
                  <label
                    htmlFor="fy"
                    style={{ fontSize: "13px", fontWeight: "400" }}
                  >
                    Financial Year:
                  </label>
                  <Select
                    id="fy"
                    value={phase}
                    onChange={onChangePhase}
                    options={phaseOptions}
                    styles={selectStyles}
                  />
                </div>
              )}

              <div
                className="ml-4 mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "0px 10px",
                }}
              >
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setfiltersData();
                  }}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Apply
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    getResetMasterData();
                  }}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer",
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            <div className="col-sm-4 text-right p-0">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  onClickUploadSkuMasterData();
                }}
                className="add-button upload-add-button"
              >
                <MdOutlineFileUpload
                  style={{ color: "#93385D", fontSize: "18px" }}
                />
                {" Upload"}
              </button>
            </div>
          </form>
          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div
              className="ag-theme-alpine"
              style={{ height: 450, width: "100%" }}
            >
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false,
                }}
                onCellClicked={handleCellClick}
              />
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {sliderType === 2 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form
              style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={(e) => {
                e.preventDefault();
                if (!dataExists) {
                  onClickingFileSubmit();
                } else {
                  e.preventDefault();
                }
              }}
            >
              <div
                className="mb-1"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Date:
                </label>
                <input
                  type="date"
                  id="uploadDate"
                  value={currentUploadedDate}
                  onChange={handleUploadDateChange}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    document.getElementById("uploadDate").showPicker?.()
                  }
                  required
                />
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
                required
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>

              <div style={{ 
                textAlign: "right", 
                marginTop: "10px", 
                display: "flex", 
                justifyContent: "flex-end", 
                gap: "10px" 
              }}>
                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={dataExists}
                  style={{
                    color: "#fff",
                    fontSize: "0.8rem",
                    backgroundColor: dataExists ? "#cccccc" : "#93385D",
                    padding: "8px 20px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: dataExists ? "not-allowed" : "pointer",
                    minWidth: "80px",
                    opacity: dataExists ? 0.6 : 1
                  }}
                >
                  Submit
                </button>

                {/* Revoke Button */}
                <button
                  type="button"
                  onClick={onClickingRevoke}
                  disabled={!dataExists}
                  style={{
                    backgroundColor: !dataExists ? "#cccccc" : "#dc3545",
                    color: "#fff",
                    fontSize: "0.8rem",
                    padding: "8px 20px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: !dataExists ? "not-allowed" : "pointer",
                    minWidth: "80px",
                    opacity: !dataExists ? 0.6 : 1
                  }}
                >
                  Revoke
                </button>
              </div>
            </form>
          </div>
        )}
      </div>

      <ChartModal
        showChart={showChart}
        setShowChart={setShowChart}
        selectedSku={selectedSku}
        phase={phase}
        skuChartData={skuChartData}
      />

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: "1px",
    borderRadius: "5px",
    border: "1px solid #d9d9d9",
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: "normal",
    color: "#333",
    fontSize: "12px",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: state.isSelected ? "normal" : "normal",
  }),
};

export default NewScreen;